import { withStyles } from '@material-ui/core/styles';
import { INSURANCE_LIST_TITLE } from '../../libraries/texts';
import service from '../../services/insurance-service';

import ListForm from '../maintainer/list';
import { MaintainerList as styles } from '../maintainer/styles';

export default withStyles(styles)(
  ListForm({ service, title: INSURANCE_LIST_TITLE, name: 'INSURANCE' })
);
